<form [formGroup]="prospectForm" id="prospectForm" novalidate>
    <section id="content">
      <!-- Draft indicator banner -->
      <div *ngIf="isEditingDraftProspect" class="draft-banner">
        <i class="pi pi-file-edit"></i> You are editing a draft prospect
      </div>
      
      <div class="spinner-container" *ngIf="loading">
        <div class="spinner">
          <div class="sk-folding-cube">
            <div class="sk-cube1 sk-cube"></div>
            <div class="sk-cube2 sk-cube"></div>
            <div class="sk-cube4 sk-cube"></div>
            <div class="sk-cube3 sk-cube"></div>
          </div>
        </div>
      </div>

      <div class="external-tabs">
        <p-messages [escape]="true" [value]="msgs"></p-messages>

        <p-steps [model]="currentStatus" [activeIndex]="currentStatusIndex"  [readonly]="true" />

        <p-tabView [(activeIndex)]="index" (onChange)="onTabChange($event)">
          <!-- Prospect Details Tab -->
          <p-tabPanel header="Prospect Details" leftIcon="pi pi-info-circle">
            <div class="tab-content" [formGroup]="prospectForm">
              <div role="tabpanel" class="tab-pane in active" id="tab-1">                <div class="card">
                  <div class="card-title">
                    <h2>{{ currentMode === 'add' ? 'Add Prospect' : currentMode === 'edit' ? 'Edit Prospect' : 'View Prospect' }}</h2>
                    <div style="position: absolute; top: 10px; right: 20px;">
                      <p-button
                        label="Create Opportunity"
                        icon="pi pi-plus-circle"
                        styleClass="p-button-success"
                        (onClick)="navigateToLeadsPage()" *ngIf="currentMode === 'edit' && hasCreateOpportunityPermission">
                      </p-button>
                    </div>
                  </div>
                  <div class="cont">
                    <div class="group">

                      <div class="collapse-title" (click)="toggleCollapse('prospectDetails')">
                        Prospect Details
                        <i class="collapse-icon fa"  ></i>
                      </div>
                      <div class="collapse in show" >
                        <div class="group-cont">
                          <div class="form-group">
                            <div class="row">
                              <!-- Brand -->
                              <!-- <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <p-dropdown [options]="brandOptions"  optionValue="value" optionLabel="label" formControlName="brandId" placeholder="Select Brand" [readonly]="isViewMode()" [showClear]="!isViewMode()" class="full-width"></p-dropdown>
                                  <label for="brandId"><span class="required" style="color:coral">*</span>Main Brand</label>                                  <div *ngIf="prospectForm.get('brandId')?.invalid && (prospectForm.get('brandId')?.dirty || prospectForm.get('brandId')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('brandId')?.errors?.['required']">Brand is required.</div>
                                  </div>
                                </div>
                              </div> -->



                                <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <app-product-tree-select [kind]="getKind()"
                                    [(selectedCategory)]="selectedCategory"
                                    [(selectedType)]="selectedType"
                                    [(selectedItem)]="selectedItem"
                                    [(selectedProductId)]="selectedProductId"
                                    selectionMode="multiple"
                                    formControlName="brandId"
                                  ></app-product-tree-select>
                                  <label for="brandId"><span class="required" style="color:coral">*</span>Brands</label>

                                  <div *ngIf="prospectForm.get('brandId')?.invalid && (prospectForm.get('brandId')?.dirty || prospectForm.get('brandId')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('brandId')?.errors?.['required']">Should select at least one Brand.</div>
                                  </div>

                                </div>
                              </div>

                              <!-- Sector - Now read-only -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <p-dropdown [options]="sectorOptions" optionValue="sectorId" optionLabel="sector" formControlName="sectorId" placeholder="Select Sector" [readonly]="true" [showClear]="false" class="full-width" [disabled]="true"></p-dropdown>
                                  <label for="sectorId"><span class="required" style="color:coral">*</span> Sector (Auto-selected)</label>                                  <div *ngIf="prospectForm.get('sectorId')?.invalid && (prospectForm.get('sectorId')?.dirty || prospectForm.get('sectorId')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('sectorId')?.errors?.['required']">Sector is required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Customer -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <p-dropdown [options]="customerOptions" optionLabel="customerName" optionValue="customerId"
                                  [virtualScroll]="true" [virtualScrollItemSize]="38" [lazy]="true" formControlName="customerId" placeholder="Select Customer"
                                  filterBy="customerNumber,customerName" filter="true" [readonly]="isViewMode()" [showClear]="!isViewMode()" class="full-width"
                                  (onChange)="onCustomerChange($event)">

                                  <ng-template let-option pTemplate="item">
                                    <span id="{{option.customerId}}">{{option.customerNumber + ' - ' +
                                      option.customerName}}</span>
                                  </ng-template>
                                </p-dropdown>
                                  <label for="customerId"><span class="required" style="color:coral">*</span> Customer</label>                                  <div *ngIf="prospectForm.get('customerId')?.invalid && (prospectForm.get('customerId')?.dirty || prospectForm.get('customerId')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('customerId')?.errors?.['required']">Customer is required.</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="form-group">
                            <div class="row">
                              <!-- Title -->
                              <div class="col-md-4 col-xs-12" >
                                <div class="inputs">
                                  <input type="text" id="title" formControlName="title" [readonly]="isViewMode()" class="full-width" />
                                  <label for="title"><span class="required" style="color:coral">*</span> Title</label>                                  <div *ngIf="prospectForm.get('title')?.invalid && (prospectForm.get('title')?.dirty || prospectForm.get('title')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('title')?.errors?.['required']">Title is required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Status -->
                              <div class="col-md-4 col-xs-12" >
                                <div class="inputs">
                                  <p-dropdown [options]="statusOptions" formControlName="status" placeholder="Select Status"  [readonly]="this.currentMode != 'add'" [showClear]="this.currentMode == 'add' " class="full-width" (onChange)="updateOddPercent($event)"></p-dropdown>
                                  <label for="status"><span class="required" style="color:coral">*</span> Status</label>                                  <div *ngIf="prospectForm.get('status')?.invalid && (prospectForm.get('status')?.dirty || prospectForm.get('status')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('status')?.errors?.['required']">Status is required.</div>
                                  </div>
                                </div>
                              </div>
                                <!-- Odd Percent -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <p-inputNumber id="oddPercent" formControlName="oddPercent" [readonly]="true" [showButtons]="false" suffix="%" [min]="0" [max]="100" class="full-width"></p-inputNumber>
                                  <label for="oddPercent"><span class="required" style="color:coral">*</span> Odd %</label>
                                </div>
                              </div>


                            </div>
                          </div>

                          <div class="form-group">
                            <div class="row">
                              <!-- Sales -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                
                                  <p-dropdown [options]="salesOptions"  optionValue="userId" optionLabel="fullName"
                                  [virtualScroll]="true" [virtualScrollItemSize]="38" [lazy]="true" formControlName="salesId" placeholder="Select Sales"
                                  filterBy="fullName" filter="true" [readonly]="isViewMode()" [showClear]="!isViewMode()" class="full-width">
                                
                                    <ng-template let-option pTemplate="selectedItem">
                                    <div class="item">
                                        <div>{{option.fullName}}</div>
                                    </div>
                                </ng-template>
                                <ng-template let-option pTemplate="item">
                                    <span id="{{option.userId}}">{{option.fullName}}</span>
                                </ng-template>
                                </p-dropdown>

                                  <label for="Sales"><span class="required" style="color:coral">*</span> Sales </label>                                  <div *ngIf="prospectForm.get('salesId')?.invalid && (prospectForm.get('salesId')?.dirty || prospectForm.get('salesId')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('salesId')?.errors?.['required']">Sales is required.</div>
                                  </div>

                                </div>
                              </div>                              <!-- Date -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <p-calendar id="date" formControlName="date" [disabled]="isViewMode()"  [readonlyInput] = "isViewMode()"
                                    [showIcon]="!isViewMode()" class="full-width" (onSelect)="onDateChange($event)"></p-calendar>
                                  <label for="date"><span class="required" style="color:coral">*</span> Date</label>                                  <div *ngIf="prospectForm.get('date')?.invalid && (prospectForm.get('date')?.dirty || prospectForm.get('date')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('date')?.errors?.['required']">Date is required.</div>
                                  </div>
                                </div>
                              </div>

                              <!-- Service Value -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <p-inputNumber id="serviceValue" formControlName="serviceValue" [readonly]="isViewMode()" mode="currency" currency="USD" locale="en-US" class="full-width"></p-inputNumber>

                                  <label for="serviceValue"><span class="required" style="color:coral">*</span>  Service Value</label>                                  <div *ngIf="prospectForm.get('serviceValue')?.invalid && (prospectForm.get('serviceValue')?.dirty || prospectForm.get('serviceValue')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('serviceValue')?.errors?.['required']">Service Value is required.</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>


                          <div *ngIf="this.currentMode == 'edit' " class="form-group">
                            <div class="row">
                              <!-- prospectCreator -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">


                                  <input pInputText  type="text"  id="prospectCreator" formControlName="prospectCreator"   readonly  class="full-width" />
                                  <label for="prospectCreator"> Created By </label>



                                </div>
                              </div>

                              <!-- creationDate -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <input pInputText type="text"  id="-creationDate" formControlName="creationDate"    readonly  class="full-width" />
                                  <label for="creationDate"> Creation Date </label>

                                </div>
                              </div>

                              <!-- countOfActivities -->
                              <div class="col-md-4 col-xs-12">
                                <div class="inputs">
                                  <p-inputNumber id="countOfActivities" formControlName="countOfActivities" readonly="true"  class="full-width"></p-inputNumber>

                                  <label for="countOfActivities"> Count Of Activities</label>

                                </div>
                              </div>
                            </div>
                          </div>                          <div class="form-group">
                            <div class="row">


                               <!-- tech leads -->
                               <div class="col-md-4 col-xs-12">
                                <div class="inputs">

                                  <p-multiSelect
                                  [options]="technicalLeadsOptions"
                                  optionValue="userId" optionLabel="fullName"
                                  variant="filled" formControlName="techLeadsIds"
                                  display="chip"   [maxSelectedLabels]="50"
                                  [readonly]="isViewMode()"  [showClear]="!isViewMode()"
                                  placeholder="Select Technical Leads" class="full-width">

                                  <ng-template let-option pTemplate="selectedItem">
                                    <div class="item">
                                      <div>{{option.firstName + " " + option.lastName}}</div>
                                    </div>
                                  </ng-template>
                                  <ng-template let-option pTemplate="item">
                                    <span id="{{option.userId}}">{{option.firstName + " " + option.lastName}}</span>
                                  </ng-template>

                                  </p-multiSelect>

                                  <label for="techLeads"><span class="required" style="color:coral">*</span> Technical Leads: </label>                                  <div *ngIf="prospectForm.get('techLeadsIds')?.invalid && (prospectForm.get('techLeadsIds')?.dirty || prospectForm.get('techLeadsIds')?.touched)" class="alert alert-danger">
                                    <div *ngIf="prospectForm.get('techLeadsIds')?.errors?.['required']">At least one Technical Lead is required.</div>
                                  </div>

                                </div>
                              </div>

                              <!-- Opportunity Selection (Only in edit mode) -->
                              <div class="col-md-4 col-xs-12" *ngIf="currentMode === 'edit'">
                                <div class="inputs">                                  <p-dropdown [options]="opportunityOptions" [(ngModel)]="selectedOpportunity"
                                    [ngModelOptions]="{standalone: true}" optionLabel="opportunityName"
                                    placeholder="Select Opportunity" [showClear]="true" class="full-width"
                                    [virtualScroll]="true" [virtualScrollItemSize]="38" [lazy]="true"
                                    filterBy="opportunityName" filter="true"
                                    (onChange)="onOpportunityChange($event.value)">
                                    <ng-template pTemplate="selectedItem" let-selectedItem>
                                      <span>{{selectedItem?.opportunityName || 'Select Opportunity'}}</span>
                                    </ng-template>
                                    <ng-template let-option pTemplate="item">
                                      <span id="{{option.opportunityId}}" 
                                            pTooltip="Year: {{option.year}}&#10;Status: {{option.status}}"
                                            tooltipPosition="left">
                                        {{option.opportunityName}}
                                      </span>
                                    </ng-template>
                                  </p-dropdown>
                                  <label for="opportunityId">Opportunity</label>
                                </div>
                              </div>

                            </div>
                          </div>

                          <!-- Remarks -->
                          <div class="form-group">
                            <div class="row">
                              <div class="col-12">
                                <div class="inputs">
                                  <textarea id="remarks" formControlName="remarks" [readonly]="isViewMode()" rows="4" class="full-width"></textarea>
                                  <label for="remarks">Remarks</label>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="wizard-cotroles">

                <p>1 Of 3</p>
                <div class="wizard-buttons">
                <p-button  class="back-btn" *ngIf="index == 1"  label="Back" icon="pi pi-arrow-left" (onClick)="navigatePrev()" />
                <p-button  class="next-btn" label="Next" icon="pi pi-arrow-right" iconPos="right" (onClick)="navigateNext()" />
                </div>
              </div>
            </div>


          </p-tabPanel>
          <!-- <p-tabPanel header="Products" leftIcon="pi pi-box">
            <div role="tabpanel" class="tab-pane" id="tab-products">
              <div class="card">
                <div class="card-title">
                  <h2>Products</h2>
                </div>

                <div class="form-actions"  style="
                margin-left: 20px;
                padding: 0px;
            " >
                  <button style="
                  padding: 10px 15px;
                  float: left;
              " pButton label="Add Product" icon="pi pi-plus" (click)="openProductDialog()"></button>
                </div>

                <div class="cont">

                  <p-table [value]="selectedProducts" [paginator]="true" [rows]="5" [responsive]="true">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Category</th>
                        <th>Type</th>
                        <th>Item</th>
                        <th>Actions</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-product>
                      <tr>
                        <td>{{ product.category?.category }}</td>
                        <td>{{ product.productType?.productType }}</td>
                        <td>{{ product.item?.item }}</td>
                        <td>
                          <button pButton type="button" icon="pi pi-trash" class="p-button-danger" (click)="deleteProduct(product)"></button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>

                </div>
              </div>
            </div>
            <div class="wizard-cotroles">

              <p>2 Of 4</p>
              <div class="wizard-buttons">
              <p-button class="back-btn" label="Prev" icon="pi pi-arrow-left" (onClick)="navigatePrev()" />
              <p-button class="next-btn" label="Next" icon="pi pi-arrow-right" iconPos="right" (onClick)="navigateNext()" />
              </div>
            </div>

          </p-tabPanel> -->
          <!-- Activities Tab -->
            <p-tabPanel header="Activities" leftIcon="pi pi-list">
            <div role="tabpanel" class="tab-pane" id="tab-2">
              <!-- Latest Activities -->
              <div class="card">
                <div class="card-title">
                  <h2>Latest Activities</h2>
                </div>
                <div class="cont">
                  <ul id="userActivities" class="latest-comments">
                    <li *ngFor="let activity of activities; let i = index">
                      <div class="cont-img">
                        <img src="" alt="">
                      </div>
                      <div class="cont-txt">
                        <h3>{{activity.title}}</h3>
                        <h4>
                          <pre>{{activity.description}}</pre>
                        </h4>
                        <p *ngIf="activity?.activityDate" class="text-sm text-gray-500 mt-1 mb-1">
                          <strong>Activity Date:</strong> {{ activity?.activityDate | date:'EEE, MM/dd/yyyy' }}
                        </p>
                        <p class="text-sm text-gray-500 mt-2"> By: {{activity.createdBy?.firstName + ' '+ activity.createdBy?.lastName}} , Status : {{activity.status}}</p>
                        <span class="date">
                          <span>Posted On: {{ activity?.postedOnDate | date:'EEE, MM/dd/yyyy' }},</span>
                          {{ activity?.postedOnTime | date:'hh:mm a' }}
                      </span>

                      <div *ngIf="activity.attendances.length > 0 && activity.attendances !=null" class="chips-container mt-2">
                        <div class="text-sm text-gray-500 mt-2">
                        Attendance:
                        </div>
                        <p-chip
                            *ngFor="let attendance of activity.attendances"
                            [label]="attendance.firstName + ' ' + attendance.lastName"
                            icon=" pi pi-user"
                            class="attachment-chip">
                        </p-chip>
                     </div>

                        <div *ngIf="activity.applianceAttachment != null" class="attachment mt-2">
                          <p class="text-sm text-gray-500 mt-2">Attachment:</p>
                        <p-button *ngIf="activity.applianceAttachment != null"  (click)="downloadAttachment(activity.applianceAttachment)"  label="{{activity.applianceAttachment.attachmentName}}" icon="pi pi-download" size="small" [link]="true" />
                      </div>

                      <div *ngIf="activity.id !=null" class="attachment mt-2">
                        <p class="text-sm text-gray-500 mt-2">Comments:</p>
                        <p-button (click)="openComentDialog(activity.id)" label="Comments ({{activity.totalComments}})" icon="pi pi-comments" size="small" [link]="true" />
                      </div>

                      <!-- Action buttons in a row - only shown if the activity was created by current user -->
                      <div class="activity-actions mt-2">
                        <div class="button-row" style="display: flex; gap: 10px;">
                          <p-button *ngIf="canEditActivity(activity)"
                                 (click)="startEditActivity(activity)" 
                                 label="Edit" 
                                 icon="pi pi-pencil" 
                                 severity="info" 
                                 size="small" />
                          <p-button *ngIf="canDeleteActivity(activity)" 
                                 (click)="deleteActivity(activity.id)" 
                                 label="Delete" 
                                 icon="pi pi-trash" 
                                 severity="danger" 
                                 size="small" />
                        </div>
                      </div>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <!-- Add Activity -->
              <div *ngIf="!isViewMode()" class="card">
                <div class="card-title">
                  <h2>{{ isEditingActivity ? 'Edit Activity' : 'Add Activity' }}</h2>
                </div>
                <div class="cont">
                  <div class="add-comment">
                    <div class="form-group">
                      <div class="inputs" id="addActivity">

                        <div class="form-group-wrapper">

                          <label>Attendance:</label>
                          <p-multiSelect
                              #attendanceMultiSelect
                              [options]="technicalLeadsOptions"
                              optionValue="userId"
                              optionLabel="fullName"
                              variant="filled"
                              [(ngModel)]="newActivityAttendance"
                              [ngModelOptions]="{standalone: true}"
                              (onChange)="onAttendanceChange($event)"
                              [readonly]="isViewMode()"
                              [showClear]="!isViewMode()"
                              placeholder="Select Technical Leads"
                              class="full-width custom-multiselect">

                              <ng-template let-option pTemplate="selectedItem">
                                  <div class="item">{{ option.firstName + " " + option.lastName }}</div>
                              </ng-template>

                              <ng-template let-option pTemplate="item">
                                  <span>{{ option.firstName + " " + option.lastName }}</span>
                              </ng-template>
                          </p-multiSelect>
                        </div>

                        <!-- Activity Date - Optional date for the activity -->
                        <div class="form-group-wrapper">
                          <label for="activityDate">Activity Date (Optional):</label>
                          <p-calendar 
                              id="activityDate" 
                              [(ngModel)]="newActivityDate" 
                              [ngModelOptions]="{standalone: true}"
                              [showIcon]="true" 
                              [disabled]="isViewMode()"
                              [readonlyInput]="isViewMode()"
                              dateFormat="dd/mm/yy"
                              placeholder="Select Date (Optional)"
                              (onSelect)="onActivityDateChange($event)"
                              styleClass="calendar-fix"
                              [style]="{'width':'100%', 'height':'34px'}"
                              [inputStyle]="{'height':'34px'}"
                              [iconButtonStyle]="{'height':'34px', 'width':'34px'}">
                          </p-calendar>
                        </div>

                        <!-- File Upload Input - Hidden when editing an activity -->
                        <div class="form-group-wrapper" *ngIf="!isEditingActivity">
                          <label for="activityAttachment">Attachment:</label>
                          <div class="file-input-wrapper">
                            <input
                                type="file"
                                id="activityAttachment"
                                (change)="onFileSelect($event)"
                                accept="*/*"
                                [disabled]="isViewMode()" />
                            <button
                                type="button"
                                pButton
                                label="Clear"
                                (click)="clearFileInput()"
                                [disabled]="isViewMode() || !newActivityAttachment"
                                class="p-button-secondary">
                            </button>
                          </div>
                        </div>




                        <input type="text" id="activityTitle" placeholder="Activity Title" [(ngModel)]="newActivityTitle" [ngModelOptions]="{standalone: true}" />
                        <textarea id="activityDescription" cols="30" rows="10" placeholder="Activity Details" [(ngModel)]="newActivityDescription" [ngModelOptions]="{standalone: true}"></textarea>
                      </div>
                    </div>
                    <div class="form-actions">
                      <!-- Show different buttons based on whether we're adding or editing -->
                      <ng-container *ngIf="!isEditingActivity">
                        <button id="post" pButton label="Post" (click)="addActivity()" 
                          [disabled]="isViewMode() || !newActivityTitle?.trim() || !newActivityDescription?.trim() || newActivityAttendance.length === 0"></button>
                      </ng-container>
                      <dev></dev>
                      <ng-container *ngIf="isEditingActivity">
                        <button pButton type="button" label="Cancel" class="p-button-secondary" style="margin-right: 10px;" 
                          (click)="cancelEditActivity()"></button>
                      
                          <button id="update" pButton label="Update" (click)="addActivity()" 
                          [disabled]="isViewMode() || !newActivityTitle?.trim() || !newActivityDescription?.trim() || newActivityAttendance.length === 0"></button>
                      </ng-container>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Navigation Controls -->
              <div class="wizard-cotroles">

                <p>2 Of 3</p>
                <div class="wizard-buttons">
                <p-button class="back-btn" label="Prev" icon="pi pi-arrow-left" (onClick)="navigatePrev()" />
                <p-button class="next-btn" label="Next" icon="pi pi-arrow-right" iconPos="right" (onClick)="navigateNext()" />
                </div>
              </div>

            </div>
          </p-tabPanel>

          <!-- Products Tab -->


          <!-- Audit History Tab -->
          <p-tabPanel header="Audit History" leftIcon="pi pi-history">
            <div role="tabpanel" class="tab-pane" id="tab-3">
              <div class="card">
                <div class="card-title">
                  <h2>Audit History</h2>
                </div>
                <div class="cont">
                  <p-table [value]="auditHistory" [paginator]="true" [rows]="10">
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Action</th>
                        <th>Action Type</th>
                        <th>User</th>
                        <th>Status</th>
                        <th>Date/Time</th>
                        <th>Description</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-audit>
                      <tr>
                        <td>{{audit.action}}</td>
                        <td>{{audit.actionType}}</td>
                       <td>{{ audit.actionBy?.firstName }} {{ audit.actionBy?.lastName }}</td>
                        <td>{{audit.status}}</td>

                        <td class="date">
                          {{ audit?.actionDate | date:'EEE, MM/dd/yyyy' }},
                          {{ audit?.actionTime | date:'hh:mm a' }}
                      </td>
                        <td>{{audit.description}}</td>
                      </tr>
                    </ng-template>
                  </p-table>
                </div>
              </div>
              <div class="wizard-cotroles">

                <p>3 Of 3</p>
                <div class="wizard-buttons">
                <p-button class="back-btn" label="Prev" icon="pi pi-arrow-left" (onClick)="navigatePrev()" />
               <!-- // <p-button class="next-btn" *ngIf="index == 3" label="Next" icon="pi pi-arrow-right" iconPos="right" (onClick)="navigateNext()" /> -->
                </div>
              </div>
            </div>
          </p-tabPanel>

              <div  *ngIf="!isViewMode()" class="form-actions">
                 <p-button  id="finish" [label]="isEditingDraftProspect ? 'Submit' : 'Submit'" (onClick)="onSubmit($event)" styleClass="p-button-primary" />
                 <p-button  *ngIf="currentMode === 'add' || isEditingDraftProspect" id="saveDraft" label="Save as Draft" (onClick)="onSaveDraft($event)" styleClass="p-button-outlined p-button-secondary" style="margin-left: 10px;" />
              </div>
        </p-tabView>
      </div>
    </section>
  </form>



  <p-dialog header="Comments" [modal]="true" [(visible)]="commentDialogVisible"  [maximizable]="true"  [style]="{ width: '50rem' , height: '50rem' }" >
    <!-- قسم التعليقات مع التمرير -->
    <div class="comments-section" #commentsSection style="max-height: 350px; overflow-y: auto; margin-bottom: 20px;">
      <!-- <div *ngFor="let comment of comments" style="margin-bottom: 15px;"> -->
        <!-- <div class="cont">
          <div class="comment-row">
            <div class="cont-img">
              <img src="../../../../assets/manager.svg" alt="{{ comment.userName }}'s profile picture" class="profile-img">
            </div>
            <div class="cont-txt">
              <strong>{{ comment.userName }}</strong>
              <small style="display: block; color: #888; margin-top: 2px;">{{ comment.creationDate | date:'EEE, MM/dd/yyyy, hh:mm a' }}</small>


                <h4>
                    <pre >{{ comment.commentText }}</pre>
                </h4>
              </div>
          </div>
        </div>
      </div> -->


      <div class="cont">
        <ul id="userCommentss" class="latest-comments" #commentsList>
          <li *ngFor="let comment of comments; let i = index">
            <div class="cont-img">
              <img src="" alt="">
            </div>
            <div class="cont-txt">
              <h3>{{comment.userName}}</h3>
              <h4>
                <pre>{{comment.commentText}}</pre>
              </h4>
              <span class="date">
                {{ comment.creationDate | date:'EEE, MM/dd/yyyy, hh:mm a' }},

            </span>

            </div>
          </li>
        </ul>
      </div>






    </div>

    <!-- نموذج إضافة تعليق جديد -->
    <div>
      <h3>Post a Comment</h3>

      <div style="margin-bottom: 5px;">
        <textarea pInputTextarea [(ngModel)]="newComment.text" placeholder="Your comment" style="width: 100%; height: 80px;"></textarea>
      </div>
      <button pButton label="Post Comment" (click)="addComment()" style="background-color: #2441aa; border: none;"></button>
    </div>
  </p-dialog>

  <!-- <p-dialog [(visible)]="productDialog" [style]="{ width: '45%' }" header="Add Product" [modal]="true" styleClass="p-fluid">
    <div class="p-grid ui-fluid">
      <div class="form-group productsClass" >
          <app-products-lists [kind]="getKind()" [(selectedCategory)]="selectedCategory" [(selectedType)]="selectedType"
          [(selectedItem)]="selectedItem" [(selectedProductId)]="selectedProductId"
          (selectionChanged)="handleSelectionChanged($event)"></app-products-lists>
      </div>

      <div style="float: right;" class="">
        <div class="formOptions">
          <button (click)="hideProductDialog()" value="cancel" style="margin-right: 5px; margin-top: 10px;" class="btn">
            <i class="fas fa-times"></i> Cancel
          </button>
          <button value="add" class="btn btn-primary" (click)="addProduct()" style="/* margin-right: 5px; */margin-top: 10px;"
            [disabled]="selectedProductId == null ">
            <i class="fas fa-plus"></i> Add
          </button>
        </div>
      </div>
    </div>
  </p-dialog> -->

  <!-- <p-confirmDialog></p-confirmDialog> -->
  <!-- Note: p-confirmDialog removed to prevent duplicate dialogs. Using global dialog in app.component.html -->
